import { render, staticRenderFns } from "./NotificationActionConfirmModal.vue?vue&type=template&id=245f00f9&scoped=true&"
import script from "./NotificationActionConfirmModal.vue?vue&type=script&lang=js&"
export * from "./NotificationActionConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationActionConfirmModal.vue?vue&type=style&index=0&id=245f00f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f00f9",
  null
  
)

export default component.exports